// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-area {
  position: relative;
  z-index: 1;
}
.about-area.bg-gradient-image {
  background-image: url('bg2.0418027ecede705e.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.about-image {
  z-index: 1;
  text-align: center;
  padding-right: 15px;
  position: relative;
}
.about-image img {
  animation: border-transform 10s linear infinite alternate forwards;
}

.about-content {
  padding-left: 15px;
}
.about-content .sub-title {
  background-color: rgba(2, 152, 148, 0.15);
  transition: var(--transition);
  color: var(--mainColor);
  display: inline-block;
  margin-bottom: 15px;
  letter-spacing: 1px;
  border-radius: 5px;
  padding: 4px 30px;
  font-size: 14px;
  font-weight: 300;
}
.about-content .sub-title:hover {
  background-color: var(--mainColor);
  color: var(--whiteColor);
}
.about-content h2 {
  margin-bottom: 10px;
  font-size: 40px;
  font-weight: 400;
  font-family: var(--fontFamily2);
}
.about-content p {
  max-width: 520px;
}
.about-content .features-list {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
  margin-top: -15px;
  margin-left: -15px;
  margin-right: -15px;
}
.about-content .features-list li {
  margin-top: 30px;
  flex: 0 0 auto;
  width: 50%;
  padding-left: 15px;
  padding-right: 15px;
}
.about-content .features-list li .icon {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 5px;
  text-align: center;
  transition: var(--transition);
  background-color: var(--whiteColor);
}
.about-content .features-list li span {
  display: block;
  margin-left: 20px;
  font-size: 24px;
  font-weight: 600;
}
.about-content .features-list li:hover .icon {
  border-radius: 50%;
}
.about-content .default-btn {
  margin-top: 30px;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .about-image {
    padding-right: 0;
  }
  .about-content {
    padding-left: 0;
    text-align: center;
    margin-top: 30px;
  }
  .about-content .sub-title {
    padding: 3px 15px;
    font-size: 12px;
  }
  .about-content h2 {
    font-size: 25px;
  }
  .about-content p {
    max-width: 100%;
  }
  .about-content .features-list {
    margin-left: -10px;
    margin-right: -10px;
  }
  .about-content .features-list li {
    padding-left: 10px;
    padding-right: 10px;
  }
  .about-content .features-list li .d-flex {
    display: block !important;
  }
  .about-content .features-list li .icon {
    width: 80px;
    height: 80px;
    line-height: 80px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
  }
  .about-content .features-list li .icon img {
    width: 45px;
  }
  .about-content .features-list li span {
    margin-left: 0;
    font-size: 16px;
  }
  .single-features-card {
    padding: 20px 15px;
  }
  .single-features-card .image {
    margin-bottom: 20px;
  }
  .single-features-card h3 {
    font-size: 20px;
    margin-bottom: 12px;
  }
}
/* Min width 576px to Max width 767px */
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .about-content .features-list li {
    width: 25%;
  }
}
/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-image {
    padding-right: 0;
    margin-bottom: 30px;
  }
  .about-content {
    padding-left: 0;
    text-align: center;
  }
  .about-content .sub-title {
    padding: 4px 20px;
    font-size: 13px;
  }
  .about-content h2 {
    font-size: 32px;
  }
  .about-content p {
    max-width: 540px;
    margin-left: auto;
    margin-right: auto;
  }
  .about-content .features-list li {
    width: 25%;
  }
  .about-content .features-list li .d-flex {
    display: block !important;
  }
  .about-content .features-list li .d-flex .icon {
    border-radius: 50%;
    margin-left: auto;
    margin-right: auto;
  }
  .about-content .features-list li .d-flex span {
    font-size: 20px;
    margin-left: 0;
    margin-top: 15px;
  }
  .single-features-card {
    padding: 25px 20px;
  }
  .single-features-card .image {
    margin-bottom: 20px;
  }
  .single-features-card h3 {
    font-size: 20px;
    margin-bottom: 12px;
  }
}
/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-image {
    padding-right: 0;
  }
  .about-content {
    padding-left: 0;
  }
  .about-content h2 {
    font-size: 36px;
  }
  .about-content p {
    max-width: 100%;
  }
  .about-content .features-list li .icon {
    width: 77px;
    height: 77px;
    line-height: 77px;
  }
  .about-content .features-list li span {
    margin-left: 15px;
    font-size: 18px;
  }
}
/* Min width 1200px to Max width 1399px */
/* Min width 1600px */
.image img {
  max-width: 80px;
}

.single-features-card {
  border: 1px solid #E5E5E5;
  background-color: var(--whiteColor);
  border-radius: 25px;
  margin-bottom: 30px;
  padding: 40px 30px;
  text-align: center;
  height: 100%;
  transition: var(--transition);
}
.single-features-card .image {
  margin-bottom: 25px;
}
.single-features-card h3 {
  margin-bottom: 13px;
  font-size: 24px;
  font-weight: 600;
}
.single-features-card:hover {
  transform: translateY(-8px);
  box-shadow: 0px 25px 65px rgba(2, 152, 148, 0.08);
  border: 1px solid var(--mainColor);
}
.single-features-card.with-black-color {
  text-align: start;
  background-color: #131A34;
  border: 1px solid #131A34;
}
.single-features-card.with-black-color h3 {
  color: var(--whiteColor);
}
.single-features-card.with-black-color p {
  color: var(--whiteColor);
}
.single-features-card.with-black-color:hover {
  box-shadow: unset;
  border: 1px solid #131A34;
}

.show-phone-number {
  background: #11b3a4;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/* ! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.z-10 {
  z-index: 10;
}
.m-0 {
  margin: 0px;
}
.m-3 {
  margin: 0.75rem;
}
.m-4 {
  margin: 1rem;
}
.m-auto {
  margin: auto;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-40 {
  margin-bottom: 10rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.table-cell {
  display: table-cell;
}
.grid {
  display: grid;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.size-11 {
  width: 2.75rem;
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-5 {
  height: 1.25rem;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-full {
  height: 100%;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-44 {
  width: 11rem;
}
.w-5 {
  width: 1.25rem;
}
.w-full {
  width: 100%;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.columns-3 {
  columns: 3;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-center {
  align-content: center;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-none {
  border-style: none;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-8 {
  padding: 2rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pr-0 {
  padding-right: 0px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-middle {
  vertical-align: middle;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.image {
  margin: auto;
  max-width: 200px;
  min-width: 200px;
  width: 20%;
  border-radius: 50%;
  border: 3px solid #6bb2e3;
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
@media (min-width: 768px) {
  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .md\\:block {
    display: block;
  }
  .md\\:hidden {
    display: none;
  }
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:justify-center {
    justify-content: center;
  }
  .md\\:p-2 {
    padding: 0.5rem;
  }
}
@media (prefers-color-scheme: dark) {
  .dark\\:border-gray-700 {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  }
  .dark\\:bg-gray-700 {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }
  .dark\\:bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  }
  .dark\\:text-gray-200 {
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity, 1));
  }
  .dark\\:hover\\:bg-gray-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
  }
  .dark\\:hover\\:bg-gray-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }
  .dark\\:hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/pages/home-demo-four/practice-detail/practice-detail.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;AACJ;AACI;EAEQ,iDAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;AAAZ;;AAIA;EACI,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AADJ;AAGI;EACI,kEAAA;AADR;;AAIA;EACI,kBAAA;AADJ;AAGI;EACI,yCAAA;EACA,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EAEI,eAAA;EACA,gBAAA;AAFZ;AAIQ;EACI,kCAAA;EACA,wBAAA;AAFZ;AAKI;EACI,mBAAA;EAEI,eAAA;EACA,gBAAA;EACA,+BAAA;AAJZ;AAOI;EACI,gBAAA;AALR;AAOI;EACI,aAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EAEI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AANZ;AAQQ;EACI,gBAAA;EACA,cAAA;EACA,UAAA;EAEI,kBAAA;EACA,mBAAA;AAPhB;AASY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mCAAA;AAPhB;AASY;EACI,cAAA;EACA,iBAAA;EAEI,eAAA;EACA,gBAAA;AARpB;AAYgB;EACI,kBAAA;AAVpB;AAeI;EACI,gBAAA;AAbR;;AAiBA,oBAAA;AACA;EAEI;IACI,gBAAA;EAfN;EAiBE;IACI,eAAA;IACA,kBAAA;IACA,gBAAA;EAfN;EAiBM;IACI,iBAAA;IACA,eAAA;EAfV;EAiBM;IACI,eAAA;EAfV;EAiBM;IACI,eAAA;EAfV;EAiBM;IAEQ,kBAAA;IACA,mBAAA;EAhBd;EAkBU;IAEQ,kBAAA;IACA,mBAAA;EAjBlB;EAmBc;IACI,yBAAA;EAjBlB;EAmBc;IACI,WAAA;IACA,YAAA;IACA,iBAAA;IAEI,iBAAA;IACA,kBAAA;IACA,mBAAA;EAlBtB;EAoBkB;IACI,WAAA;EAlBtB;EAqBc;IACI,cAAA;IACA,eAAA;EAnBlB;EAyBA;IACE,kBAAA;EAvBF;EAyBE;IACE,mBAAA;EAvBJ;EAyBE;IACE,eAAA;IACA,mBAAA;EAvBJ;AACF;AA4BA,uCAAA;AACA;EAIY;IACI,UAAA;EA7Bd;AACF;AAmCA,uCAAA;AACA;EAEI;IACI,gBAAA;IACA,mBAAA;EAlCN;EAoCE;IACI,eAAA;IACA,kBAAA;EAlCN;EAoCM;IACI,iBAAA;IACA,eAAA;EAlCV;EAoCM;IACI,eAAA;EAlCV;EAoCM;IACI,gBAAA;IAEI,iBAAA;IACA,kBAAA;EAnCd;EAuCU;IACI,UAAA;EArCd;EAuCc;IACI,yBAAA;EArClB;EAuCkB;IACI,kBAAA;IAEI,iBAAA;IACA,kBAAA;EAtC1B;EAyCkB;IACI,eAAA;IAEI,cAAA;IACA,gBAAA;EAxC1B;EA+CA;IACE,kBAAA;EA7CF;EA+CE;IACE,mBAAA;EA7CJ;EA+CE;IACE,eAAA;IACA,mBAAA;EA7CJ;AACF;AAkDA,wCAAA;AACA;EAEI;IACI,gBAAA;EAjDN;EAmDE;IACI,eAAA;EAjDN;EAmDM;IACI,eAAA;EAjDV;EAmDM;IACI,eAAA;EAjDV;EAqDc;IACI,WAAA;IACA,YAAA;IACA,iBAAA;EAnDlB;EAqDc;IACI,iBAAA;IACA,eAAA;EAnDlB;AACF;AA0DA,yCAAA;AAGA,qBAAA;AAIA;EACE,eAAA;AA7DF;;AAgEA;EACE,yBAAA;EACA,mCAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;AA7DF;AA+DE;EACE,mBAAA;AA7DJ;AA+DE;EACE,mBAAA;EAEE,eAAA;EACA,gBAAA;AA9DN;AAiEE;EACE,2BAAA;EACA,iDAAA;EACA,kCAAA;AA/DJ;AAiEE;EACE,iBAAA;EACA,yBAAA;EACA,yBAAA;AA/DJ;AAiEI;EACE,wBAAA;AA/DN;AAiEI;EACE,wBAAA;AA/DN;AAiEI;EACE,iBAAA;EACA,yBAAA;AA/DN;;AAoEA;EACE,mBAAA;AAjEF;;AAmEA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA;;AAAA,kEAAA;;AAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;;AAAA;EAAA,aAAA;AAAA;AACA;EAAA,WAAA;AAAA;AAAA;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AACA;EAAA,oBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,4BAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,cAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA;IAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,2BAAA;AAAA;AAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,8BAAA;AAAA;AAAA;EAAA,6BAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,SAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,eAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,kDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iLAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,0BAAA;AAAA;AAGA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AAlEF;AA3RA;EAAA,kBA2RA;EA3RA,0DAAA;AA2RA;AA3RA;EAAA,kBA2RA;EA3RA,4DAAA;AA2RA;AA3RA;EAAA,kBA2RA;EA3RA,yDAAA;AA2RA;AA3RA;EAAA,+BAAA;AA2RA;AA3RA;EAAA,+EA2RA;EA3RA,mGA2RA;EA3RA,uGAAA;AA2RA;AA3RA;EAAA,8BA2RA;EA3RA,mBAAA;AA2RA;AA3RA;EAAA,2GA2RA;EA3RA,yGA2RA;EA3RA,4FAAA;AA2RA;AA3RA;EAAA,oBA2RA;EA3RA,6DAAA;AA2RA;AA3RA;EAAA;IAAA,4BAAA;EA2RA;EA3RA;IAAA,4BAAA;EA2RA;EA3RA;IAAA,cAAA;EA2RA;EA3RA;IAAA,aAAA;EA2RA;EA3RA;IAAA,gDAAA;EA2RA;EA3RA;IAAA,gDAAA;EA2RA;EA3RA;IAAA,uBAAA;EA2RA;EA3RA;IAAA,eAAA;EA2RA;AAAA;AA3RA;EAAA;IAAA,sBA2RA;IA3RA,yDAAA;EA2RA;EA3RA;IAAA,kBA2RA;IA3RA,yDAAA;EA2RA;EA3RA;IAAA,kBA2RA;IA3RA,yDAAA;EA2RA;EA3RA;IAAA,oBA2RA;IA3RA,mDAAA;EA2RA;EA3RA;IAAA,kBA2RA;IA3RA,yDAAA;EA2RA;EA3RA;IAAA,kBA2RA;IA3RA,yDAAA;EA2RA;EA3RA;IAAA,oBA2RA;IA3RA,mDAAA;EA2RA;AAAA;AA+kCA,wlsBAAwlsB","sourcesContent":[".about-area {\n    position: relative;\n    z-index: 1;\n\n    &.bg-gradient-image {\n        background: {\n            image: url(../../../../../assets/img/bg/bg2.jpg);\n            position: center center;\n            repeat: no-repeat;\n            size: cover;\n        };\n    }\n}\n.about-image {\n    z-index: 1;\n    text-align: center;\n    padding-right: 15px;\n    position: relative;\n\n    img {\n        animation: border-transform 10s linear infinite alternate forwards;\n    }\n}\n.about-content {\n    padding-left: 15px;\n\n    .sub-title {\n        background-color: rgba(2, 152, 148, .15);\n        transition: var(--transition);\n        color: var(--mainColor);\n        display: inline-block;\n        margin-bottom: 15px;\n        letter-spacing: 1px;\n        border-radius: 5px;\n        padding: 4px 30px;\n        font: {\n            size: 14px;\n            weight: 300;\n        };\n        &:hover {\n            background-color: var(--mainColor);\n            color: var(--whiteColor);\n        }\n    }\n    h2 {\n        margin-bottom: 10px;\n        font: {\n            size: 40px;\n            weight: 400;\n            family: var(--fontFamily2);\n        };\n    }\n    p {\n        max-width: 520px;\n    }\n    .features-list {\n        display: flex;\n        flex-wrap: wrap;\n        padding-left: 0;\n        list-style-type: none;\n        margin: {\n            bottom: 0;\n            top: -15px;\n            left: -15px;\n            right: -15px;\n        };\n        li {\n            margin-top: 30px;\n            flex: 0 0 auto;\n            width: 50%;\n            padding: {\n                left: 15px;\n                right: 15px;\n            };\n            .icon {\n                width: 100px;\n                height: 100px;\n                line-height: 100px;\n                border-radius: 5px;\n                text-align: center;\n                transition: var(--transition);\n                background-color: var(--whiteColor);\n            }\n            span {\n                display: block;\n                margin-left: 20px;\n                font: {\n                    size: 24px;\n                    weight: 600;\n                };\n            }\n            &:hover {\n                .icon {\n                    border-radius: 50%;\n                }\n            }\n        }\n    }\n    .default-btn {\n        margin-top: 30px;\n    }\n}\n\n/* Max width 767px */\n@media only screen and (max-width : 767px) {\n\n    .about-image {\n        padding-right: 0;\n    }\n    .about-content {\n        padding-left: 0;\n        text-align: center;\n        margin-top: 30px;\n\n        .sub-title {\n            padding: 3px 15px;\n            font-size: 12px;\n        }\n        h2 {\n            font-size: 25px;\n        }\n        p {\n            max-width: 100%;\n        }\n        .features-list {\n            margin: {\n                left: -10px;\n                right: -10px;\n            };\n            li {\n                padding: {\n                    left: 10px;\n                    right: 10px;\n                };\n                .d-flex {\n                    display: block !important;\n                }\n                .icon {\n                    width: 80px;\n                    height: 80px;\n                    line-height: 80px;\n                    margin: {\n                        left: auto;\n                        right: auto;\n                        bottom: 15px;\n                    };\n                    img {\n                        width: 45px;\n                    }\n                }\n                span {\n                    margin-left: 0;\n                    font-size: 16px;\n                }\n            }\n        }\n    }\n\n  .single-features-card {\n    padding: 20px 15px;\n\n    .image {\n      margin-bottom: 20px;\n    }\n    h3 {\n      font-size: 20px;\n      margin-bottom: 12px;\n    }\n  }\n\n}\n\n/* Min width 576px to Max width 767px */\n@media only screen and (min-width : 576px) and (max-width : 767px) {\n\n    .about-content {\n        .features-list {\n            li {\n                width: 25%;\n            }\n        }\n    }\n\n}\n\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width : 768px) and (max-width : 991px) {\n\n    .about-image {\n        padding-right: 0;\n        margin-bottom: 30px;\n    }\n    .about-content {\n        padding-left: 0;\n        text-align: center;\n\n        .sub-title {\n            padding: 4px 20px;\n            font-size: 13px;\n        }\n        h2 {\n            font-size: 32px;\n        }\n        p {\n            max-width: 540px;\n            margin: {\n                left: auto;\n                right: auto;\n            };\n        }\n        .features-list {\n            li {\n                width: 25%;\n\n                .d-flex {\n                    display: block !important;\n\n                    .icon {\n                        border-radius: 50%;\n                        margin: {\n                            left: auto;\n                            right: auto;\n                        };\n                    }\n                    span {\n                        font-size: 20px;\n                        margin: {\n                            left: 0;\n                            top: 15px;\n                        };\n                    }\n                }\n            }\n        }\n    }\n  .single-features-card {\n    padding: 25px 20px;\n\n    .image {\n      margin-bottom: 20px;\n    }\n    h3 {\n      font-size: 20px;\n      margin-bottom: 12px;\n    }\n  }\n\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width : 992px) and (max-width : 1199px) {\n\n    .about-image {\n        padding-right: 0;\n    }\n    .about-content {\n        padding-left: 0;\n\n        h2 {\n            font-size: 36px;\n        }\n        p {\n            max-width: 100%;\n        }\n        .features-list {\n            li {\n                .icon {\n                    width: 77px;\n                    height: 77px;\n                    line-height: 77px;\n                }\n                span {\n                    margin-left: 15px;\n                    font-size: 18px;\n                }\n            }\n        }\n    }\n\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {}\n\n/* Min width 1600px */\n@media only screen and (min-width: 1600px) {}\n\n\n.image img{\n  max-width: 80px;\n}\n\n.single-features-card {\n  border: 1px solid #E5E5E5;\n  background-color: var(--whiteColor);\n  border-radius: 25px;\n  margin-bottom: 30px;\n  padding: 40px 30px;\n  text-align: center;\n  height: 100%;\n  transition: var(--transition);\n\n  .image {\n    margin-bottom: 25px;\n  }\n  h3 {\n    margin-bottom: 13px;\n    font: {\n      size: 24px;\n      weight: 600;\n    };\n  }\n  &:hover {\n    transform: translateY(-8px);\n    box-shadow: 0px 25px 65px rgba(2, 152, 148, 0.08);\n    border: 1px solid var(--mainColor);\n  }\n  &.with-black-color {\n    text-align: start;\n    background-color: #131A34;\n    border: 1px solid #131A34;\n\n    h3 {\n      color: var(--whiteColor);\n    }\n    p {\n      color: var(--whiteColor);\n    }\n    &:hover {\n      box-shadow: unset;\n      border: 1px solid #131A34;\n    }\n  }\n}\n\n.show-phone-number{\n  background: #11b3a4;\n}\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n.image{\n  margin: auto;\n  max-width: 200px;\n  min-width: 200px;\n  width: 20%;\n  border-radius: 50%;\n  border: 3px solid #6bb2e3;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
